<template>
    <div class="page-loader">
        <q-spinner-pie color="primary" size="40px" />
    </div>
</template>

<script>
export default {}
</script>
